module.exports = __webpack_public_path__ + "static/media/blank.371b75e8.gif";